/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';

const SrInformationLabel = ({ text }) => (
  <SrBox borderRadius="8px" backgroundColor="#f1f1f1" padding="16px">
    <SrFlex>
      <img
        alt="information"
        src="/images/information-icon-yellow.svg"
        width="22px"
        height="22px"
        style={{
          filter: 'drop-shadow(0px 4px 7px rgba(234, 188, 3, 0.26))',
          marginRight: '16px',
          marginTop: '4px',
          flexShrink: '0',
        }}
      />
      <SrText font="greycliff" color="blueGreycliff" weight="700" size="14" lineHeight="20px">
        {text}
      </SrText>
    </SrFlex>
  </SrBox>
);

SrInformationLabel.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

SrInformationLabel.displayName = 'SrInformationLabel';

export default SrInformationLabel;
